<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <v-card>
          <v-toolbar color="primary" dark>
            <v-toolbar-title class="white--text"
              >Shipping Setting</v-toolbar-title
            >
            <v-spacer />
            <v-toolbar-items>
              <v-btn v-if="profiles.length === 0" flat @click="addProfile()"
                >Add New</v-btn
              >
              <v-btn v-if="edit" flat @click="addRate()">Add Rate</v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-card-text>
            <v-list two-line v-if="!edit">
              <v-list-tile :key="profile.id" v-for="profile in profiles">
                <v-list-tile-content>
                  <v-list-tile-title>{{ profile.name }}</v-list-tile-title>
                  <v-list-tile-subtitle>
                    All countries
                  </v-list-tile-subtitle>
                  <v-list-tile-subtitle>All Products</v-list-tile-subtitle>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-icon color="blue" @click="editProfile(profile.id)">
                    mdi-pencil
                  </v-icon>

                  <v-icon color="red" @click="deleteProfile(profile.id)">
                    mdi-delete
                  </v-icon>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
            <div v-else-if="profile">
              <v-text-field label="Name" v-model="profile.name" />
              <v-data-table
                :headers="headers"
                :items="profile.rates"
                :loading="loading"
                class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.amount }}</td>
                  <td>{{ props.item.min }}</td>
                  <td>{{ props.item.max }}</td>
                  <td>{{ props.item.type }}</td>
                  <td>
                    <v-icon
                      color="blue"
                      class="mr-3"
                      @click="editRate(props.item)"
                    >
                      mdi-pencil
                    </v-icon>

                    <v-icon color="red" @click="deleteRate(props.item.id)">
                      mdi-delete
                    </v-icon>
                  </td>
                </template>
              </v-data-table>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="rateDialog" width="400">
      <v-card v-if="rate">
        <v-card-text>
          <v-layout row>
            <v-flex>
              <v-text-field label="Name*" v-model="rate.name" />
            </v-flex>
            <v-flex>
              <v-text-field label="Amount" v-model.number="rate.amount" />
            </v-flex>
          </v-layout>
          <span
            class="info--text"
            style="cursor:pointer;"
            @click="rate.conditional = !rate.conditional"
            >{{ rate.conditional ? 'remove' : 'add' }} condition</span
          >
          <div v-if="rate.conditional">
            <span>Based On</span>
            <v-radio-group v-model="rate.type" row>
              <v-radio color="primary" label="Weight" value="weight"></v-radio>
              <v-radio
                color="primary"
                label="Order Amount"
                value="amount"
              ></v-radio>
            </v-radio-group>
            <v-text-field
              :label="
                'Min ' +
                  (rate.type === 'weight' ? 'weight (g)' : 'order amount')
              "
              v-model.number="rate.min"
            />
            <v-text-field
              :label="
                'Max ' +
                  (rate.type === 'weight' ? 'weight (g)' : 'order amount')
              "
              v-model.number="rate.max"
            />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            :disabled="!rate.name"
            :loading="saving"
            color="success"
            @click="saveRate()"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import api from '../../api';

export default {
  data() {
    return {
      profiles: [],
      loading: false,
      edit: false,
      profile: null,
      creating: false,
      rateDialog: false,
      rate: null,
      saving: false,
      headers: [
        {
          text: 'Name',
          align: 'left',
          sortable: false,
          value: 'name',
        },
        { text: 'Amount', value: 'amount' },
        { text: 'Min', value: 'min' },
        { text: 'Max', value: 'max' },
        { text: 'Type', value: 'type' },
        { text: 'Actions', value: '' },
      ],
    };
  },
  created() {
    this.loading = true;
    api.get('vendors/settings/shipping').then(r => {
      this.profiles = r.data;
      this.loading = false;
    });
  },
  methods: {
    addProfile() {
      this.creating = true;
      api.post('vendors/settings/shipping', { name: 'default' }).then(r => {
        this.profiles.push(r.data);
        this.creating = false;
      });
    },
    editProfile(id) {
      this.edit = true;
      this.loading = true;
      api.get('vendors/settings/shipping/' + id).then(r => {
        this.profile = r.data;
        this.loading = false;
      });
    },
    addRate() {
      this.rate = {
        name: '',
        amount: 0,
        conditional: false,
        min: null,
        max: null,
        type: 'weight',
      };
      this.rateDialog = true;
    },
    editRate(rate) {
      this.rate = rate;
      this.rateDialog = true;
    },
    saveRate() {
      this.saving = true;
      if (!this.rate.id) {
        api
          .post(
            'vendors/settings/shipping/' + this.profile.id + '/rate',
            this.rate,
          )
          .then(r => {
            this.profile.rates.push(r.data);
            this.saving = false;
            this.rateDialog = false;
          });
      } else {
        const { id, ...rate } = this.rate;
        api
          .put(
            'vendors/settings/shipping/' + this.profile.id + '/rate/' + id,
            rate,
          )
          .then(r => {
            const i = this.profile.rates.findIndex(
              rate => rate.id === r.data.id,
            );
            if (i > -1) this.profile.rates.splice(i, 1, r.data);
            this.saving = false;
            this.rateDialog = false;
          });
      }
    },
    deleteRate(id) {
      api
        .delete('vendors/settings/shipping/' + this.profile.id + '/rate/' + id)
        .then(r => {
          const i = this.profile.rates.findIndex(rate => rate.id === id);
          if (i > -1) this.profile.rates.splice(i, 1);
          this.saving = false;
          this.rateDialog = false;
        });
    },
  },
};
</script>
